import { useTranslation } from "react-i18next";

import { userRoles } from "@/constants/UserRoles";

export default function () {
  const { t } = useTranslation();

  return {
    filterMode: "tree",
    filters: userRoles.map(({ name }) => {
      return {
        text: t(`role:${name.replace(".", "")}`),
        value: name,
      };
    }),
  };
}
